export const COMPONENT_NAME = "application-form-score";
